import { z } from 'zod/v4';
import { CourtSubmitConfigSchema } from '../court/auto-submit.js';
import { CaseMergeRulesSchema, RegistryIdentifierSchema, } from '../customers/index.js';
import { PaymentPlansConfigSchema, } from '../economy/payment-plans/index.js';
import { AddressSchema, BankAccountSchema, } from '../index.js';
import { DefaultProceduresSchema, } from '../procedures/index.js';
import { ResponsibleForUpdateTypesSchema } from '../teams/index.js';
import { BillingTextFieldSettingsSchema, PriceListSchema, } from '../tenants/index.js';
import { TribunalCaseType } from '../tribunal/cases/types.js';
import { CaseGroupWorkflowsSchema, } from '../workflows/index.js';
export var CreditorState;
(function (CreditorState) {
    CreditorState["Lead"] = "LEAD";
    CreditorState["SignedOn"] = "SIGNED_ON";
    CreditorState["Active"] = "ACTIVE";
    CreditorState["Cancelled"] = "CANCELLED";
    CreditorState["Ceased"] = "CEASED";
})(CreditorState || (CreditorState = {}));
/** Creditors that new cases can be created or imported for */
export const canReceiveCases = (creditor) => [CreditorState.Active, CreditorState.Lead, CreditorState.SignedOn].includes(creditor.state);
export const CreditorTribunalSettingsSchema = z.object({
    caseTypes: z
        .object({
        [TribunalCaseType.DKFogedrekvisition]: z
            .object({
            defaultEmailTemplateId: z.uuid().nullable().optional(),
            defaultEmailAttachmentTemplateId: z.uuid().nullable().optional(),
        })
            .optional(),
        [TribunalCaseType.DKAndreFogedsager]: z
            .object({
            defaultEmailTemplateId: z.uuid().nullable().optional(),
            defaultEmailAttachmentTemplateId: z.uuid().nullable().optional(),
        })
            .optional(),
    })
        .optional(),
});
export const CreditorSettingsSchema = z.object({
    overrideAutoDebtRegister: z.boolean().optional(),
    autoDebtRegister: z.boolean().optional(),
    autoRegisterInOpenRegistry: z.boolean().optional(),
    autoIgnoreUnresolvedOppositions: z.boolean().optional(),
    customExpiration: z
        .object({
        normal: z.number().optional(),
        foundation: z.number().optional(),
        interest: z.number().optional(),
    })
        .optional(),
    eInvoice: z
        .object({
        companyId: z.string(),
        childCompanyId: z.string(),
        organizationIdentifier: RegistryIdentifierSchema,
    })
        .optional(),
    courtSubmitConfig: CourtSubmitConfigSchema.optional(),
    responsibleForUpdateTypes: ResponsibleForUpdateTypesSchema.optional(),
    billingTextFieldSettings: BillingTextFieldSettingsSchema.nullish(),
    tribunal: CreditorTribunalSettingsSchema.optional(),
    ai: z
        .object({
        customInstructions: z.string().nullish(),
    })
        .optional(),
    costCeiling: z
        .object({
        enabled: z.boolean().optional(),
    })
        .optional(),
});
export const UpdateCreditorSchema = z.object({
    id: z.string().nullish(),
    referenceId: z.string().nullish(),
    name: z.string().nullish(),
    erpLink: z.string().nullish(),
    state: z.enum(CreditorState).nullish(),
    defaultWorkflowId: z.string().nullish(),
    caseMergeRules: CaseMergeRulesSchema.nullish(),
    paymentPlansConfig: PaymentPlansConfigSchema.nullish(),
    defaultCollectorId: z.string().nullish(),
    defaultBillingModelId: z.string().nullish(),
    defaultBillingAppendixSetupId: z.string().nullish(),
    acquisitionResponsibleId: z.string().nullish(),
    contactId: z.string().nullish(),
    caseworkerContactId: z.string().nullish(),
    caseImportMap: z.record(z.string(), z.array(z.string())).nullish(),
    notes: z.string().nullish(),
    debtorFAQ: z.string().nullish(),
    selfCollection: z.boolean().nullish(),
    autoVerify: z.boolean().nullish(),
    defaultProcedures: DefaultProceduresSchema.nullish(),
    vatRegistered: z.boolean().nullish(),
    isCompany: z.boolean().nullish(),
    address: AddressSchema.nullish(),
    centralRegisterId: z.string().nullish(),
    aksEnabled: z.boolean().nullish(),
    experianClientId: z.string().nullish(),
    debitorRegistretCreditorNumber: z.string().nullish(),
    priceList: PriceListSchema.nullish(),
    outboundCall: z.boolean().nullish(),
    allowedIntegrations: z.array(z.string()).optional(),
    customVoucherApplications: z.boolean().optional(),
    caseGroupWorkflows: z.array(CaseGroupWorkflowsSchema).optional(),
    settings: z.lazy(() => CreditorSettingsSchema).optional(),
    bankAccountDetails: BankAccountSchema.nullish(),
    paymentTerms: z.object({ paymentDays: z.number() }).nullish(),
    billingEmails: z
        .object({
        to: z.string().nullable(),
        cc: z.string().nullable(),
        bcc: z.string().nullable(),
    })
        .nullish(),
    minimumBillingLimit: z.number().nullish(),
});
//# sourceMappingURL=index.js.map